import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    dropCache: {
        drpPrioritiesOptions: null,
        drpCompaniesOptions: null,
        drpAssetCategoriesOptions: null,
        drpAssetsOptions: null,
        ticketAssignedUsersOptions: null,
        drpContactTypesOptions: null,
    },
    dropSelectedCache: {
        selectedPriority: null,
        selectedCompany: null,
        selectedCustomer:null,
        selectedCategory: null,
        selectedAsset: null,
        selectedTicketAssignedUser: null,
        selectedContactType: null
    }

}

const dropSlice = createSlice({
    name: "drop",
    initialState,
    reducers: {
        setDropdownOptions: (state, action) => {
            const { dropdownType, options } = action.payload;
            state.dropCache[dropdownType] = options;
        },
        removeDropdownOption: (state, action) => {
            const { dropdownType } = action.payload;
            if (state.dropCache.hasOwnProperty(dropdownType)) {
                delete state.dropCache[dropdownType];
            }
        },

        setSelectedDropdownValue: (state, action) => {
            const { dropdownType, value } = action.payload;
            state.dropSelectedCache[dropdownType] = value;
        },

    }
})

export const { setDropdownOptions,removeDropdownOption,setSelectedDropdownValue } = dropSlice.actions;

export default dropSlice.reducer;
